window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    // window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}

/*
 * axios was required here and was never called — removed 2026-08-13 (audit B-7).
 *
 * It came with Laravel's scaffolding, was given a default header, and that was
 * the whole of its involvement: every request this site makes goes through
 * `fetch` (eleven of them) or a plain `XMLHttpRequest` (three). It was shipped
 * to every visitor in the bundle regardless.
 *
 * Deleting it rather than upgrading it also closes the finding outright. The
 * version in use, 0.21.4, carries advisories that the 1.x line fixed — the
 * notable one being the XSRF token attached on a cross-origin redirect — and
 * whether that mattered here was never established. It cannot matter now.
 */

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
